module.exports = __webpack_public_path__ + "img/fashion_77.2e8a9162.jpg";